import {toast, ToastContainer} from "react-toastify";

export default class ToastService {
  static info(message: any, position: any = "top-right", autoClose: number = 5000): void {
    toast.info(message, {
      position: position,
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      width: "500px",
      toastId: message
    } as any);
  }

  static error(message: any, position: any = "top-right"): void {
    toast.error(message, {
      position: position,
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: message
    });
  }

  static success(message: any, position: any = "top-right", autoClose: number = 5000): void {
    toast.success(message, {
      position: position,
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: message
    });
  }

  static warning(message: any, position: any = "top-right"): void {
    toast.warning(message, {
      position: position,
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: message
    });
  }
}

export {toast, ToastContainer};
